import React, {useEffect, useState} from "react";
import {Box, Button, Divider, Typography, useMediaQuery} from "@mui/material";
import {FlyerPagesTocEntriesDto, FlyerTocDto, PageRunsDto, PopupDataDto} from "../../dtos";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {FlippingFlyerToCTabItem} from "./flippingFlyerToCTabItem";
import {AddEditToCCaption} from "./addEditToCCaption";
import {makeStyles} from "@mui/styles";
import {convertPagesRangeToString} from "../../globals/globFunctions";
import {SortBtn} from "../com/sortBtn/sortBtn";

const useStyles = makeStyles(() => ({
    addButton: {
        "&.MuiButton-root": {
            backgroundColor: "#014780",
            borderRadius: 0,
            padding: "4px",
            color: `initial`,
            minHeight: "40px",
            maxWidth: "40%",
            background: `#014780`,
            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
            '&:hover': {
                background: `#014780`,
                opacity: `0.7`
            },
            '&:disabled': {
                opacity: `0.5`
            }
        }
    },
    tableHeader: {
        display: "flex",
        flexFlow: "row",
        minHeight: "40px",
        // padding: "4px 2px",
        // paddingLeft: isXs ? "4px" : "16px",
        border: "1px solid #DDDDDD",
        position: "sticky",
        zIndex: 1,
        top: 0,
        backgroundColor: "#ffffff"
    },
    captionsHeader: {
        flex: "1 1 auto",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    pagesHeader: {
        padding: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    sortButton: {
        "&.MuiButton-root": {
            display: "flex",
            alignItems: "center",
            cursor: "pointer"
        }
    },
    doubleArrowSortBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "20px",
        height: "20px"
    },
    divider: {
        "&.MuiDivider-root": {
            width: `1px`,
            backgroundColor: "#DDDDDD",
            borderWidth: "0"
        }
    },
    contentWrapper: {
        background: "white",
        padding: 0,
        width: `100%`,
        flex: "1 1 auto",
        // overflow: "auto",
    }
}))

// a little function to help us with reordering the result
/*
const reorder = (list: FlyerTocEntriesDto[], startIndex: number, endIndex: number): FlyerTocEntriesDto[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
*/

export interface ConfigDto {
    caption: string;
    direction: string;
}


export const FlippingFlyerTocTab = () => {
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const isXs = useMediaQuery(`(max-width:599px)`);

    const [items, setItems] = useState<FlyerPagesTocEntriesDto[]>([]);
    const [defaultItems, setDefaultItems] = useState<FlyerPagesTocEntriesDto[]>([]);
    const [sortConfig, setSortConfig] = useState<ConfigDto | null>(null);
    const [popupData, setPopupData] = useState<PopupDataDto>({
        isOpen: false,
        pageTocCaption: null,
        pageRange: [],
        isNew: false,
        tocEntryId: null
    });

    const classes = useStyles();
    useEffect(() => {
        const items: FlyerPagesTocEntriesDto[] = [];

        flyerDetailsState.toc.forEach((toc: FlyerTocDto) => {
            if (toc) {
                const data: FlyerPagesTocEntriesDto = {
                    ...toc.tocEntryDto,
                    pageRange: toc.pageRuns
                    // caption: "ca",
                    // flyerId: page.flpflyRecId!,
                    // id: 0,
                    // orderInParent: 0,
                    // pageId: 1,
                    // // pageNumber: Math.round(Math.random() * 100),
                    // pageNumber: 1
                }
                items.push(data);
            }
        })
        setItems(items);
        setDefaultItems(items);
    }, [flyerDetailsState.toc]);

    // useEffect(() => {
    //     if(tocForPage.type === ActionType.DELETE_TOC_FOR_PAGE_SUCCESS){
    //         const newTocArray = items.filter((toc: FlyerPagesTocEntriesDto) => toc.id !== tocForPage.tocForPage?.id);
    //         setItems(newTocArray);
    //     }
    // }, [tocForPage]);


    useEffect(() => {
        if (sortConfig) {
            let sortableItems = [...items];
            sortableItems.sort((a, b) => {
                if (sortConfig.caption === "pageRange") {
                    // console.log(a[sortConfig.caption as keyof FlyerPagesTocEntriesDto]);
                    const nonConvertA = a[sortConfig.caption as keyof FlyerPagesTocEntriesDto];
                    const nonConvertB = b[sortConfig.caption as keyof FlyerPagesTocEntriesDto];
                    const convertA = convertPagesRangeToString(nonConvertA as PageRunsDto[]);
                    const firstNumberA = convertA.match(/[0-9]+/);
                    const convertB = convertPagesRangeToString(nonConvertB as PageRunsDto[]);
                    const firstNumberB = convertB.match(/[0-9]+/);
                    if (Number(firstNumberA) < Number(firstNumberB)) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (Number(firstNumberA) > Number(firstNumberB)) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                } else {
                    if (a[sortConfig.caption as keyof FlyerPagesTocEntriesDto].toString().toLowerCase() < b[sortConfig.caption as keyof FlyerPagesTocEntriesDto].toString().toLowerCase()) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.caption as keyof FlyerPagesTocEntriesDto].toString().toLowerCase() > b[sortConfig.caption as keyof FlyerPagesTocEntriesDto].toString().toLowerCase()) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                }
                return 0;
            });
            setItems(sortableItems);
        }
    }, [sortConfig]);

    const openPopup = (itemData: FlyerPagesTocEntriesDto | null = null) => {
        if (itemData) {
            setPopupData({
                isOpen: true,
                pageRange: itemData.pageRange,
                pageTocCaption: itemData.caption,
                isNew: false,
                tocEntryId: itemData.id
            })
        } else {
            setPopupData({
                isOpen: true,
                pageRange: [],
                pageTocCaption: null,
                isNew: true,
                tocEntryId: null,
            })
        }

    }

    const closePopup = () => {
        setPopupData({
            isOpen: false,
            pageRange: [],
            pageTocCaption: null,
            isNew: false,
            tocEntryId: null
        })
    }

    /*
        const onDragEnd = (result: DropResult) => {
            // dropped outside the list
            if (!result.destination) {
                return;
            }

            const newItems: FlyerTocEntriesDto[] = reorder(
                items,
                result.source.index,
                result.destination.index
            );

            setItems(newItems);
        }
    */

    const pagesItems = items.map((item) => (
        <FlippingFlyerToCTabItem key={item.id} item={item} openPopup={openPopup}/>
    ))

    return (
        <Box sx={{
            display: "flex",
            flexFlow: "column",
            height: "100%"
        }}>
            <Button
                onClick={() => {
                    openPopup();
                }}
                className={classes.addButton}>
                <Typography color={"#ffffff"}>
                    Add caption
                </Typography>
            </Button>
            <Box
                sx={{
                    flex: "1 1 auto",
                    overflow: "auto",
                    display: "flex",
                    flexFlow: "column"
                }}
                mt={"10px"}>
                <Box className={classes.tableHeader}>
                    <Box className={classes.captionsHeader}>
                        <Typography fontWeight={700}>
                            Table of Content Caption
                        </Typography>
                        <SortBtn sortCaption={"caption"} items={pagesItems} setSortConfig={setSortConfig} sortConfig={sortConfig}/>
                    </Box>
                    <Divider orientation="vertical" flexItem
                             className={classes.divider}
                    />
                    <Box
                        className={classes.pagesHeader}
                        sx={{
                            minWidth: isXs ? "30%" : "30%",
                            width: isXs ? "30%" : "30%",
                        }}
                    >
                        <Typography fontWeight={700} textAlign={"start"}>
                            Page
                        </Typography>
                        <SortBtn sortCaption={"pageRange"} items={pagesItems} setSortConfig={setSortConfig} sortConfig={sortConfig}/>
                    </Box>
                </Box>
                {/*<DragDropContext onDragEnd={onDragEnd}>*/}
                {/*    <Droppable droppableId="droppable">*/}
                {/*        {(provided, snapshot) => (*/}
                <Box
                    className={classes.contentWrapper}
                    //{...provided.droppableProps}
                    // ref={provided.innerRef}
                >
                    {pagesItems}
                    {/*{provided.placeholder}*/}
                </Box>
                {/*)}*/}
                {/*    </Droppable>*/}
                {/*</DragDropContext>*/}
            </Box>
            <AddEditToCCaption popupData={popupData} closePopup={closePopup}/>
        </Box>
    )
}